import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

import { UbsAgreementIdSchema } from './ubs-agreement-id.ts'
import { UbsEntityIdSchema } from './ubs-entity-id.ts'

export const UbsAgreementSchema = z.object({
  agreementId: UbsAgreementIdSchema,
  ubsEntityId: UbsEntityIdSchema,
  serviceId: z.number().nullish(),
  serviceName: z.string().nullish(),
  startDate: DateStringSchema,
  endDate: DateStringSchema.nullish(),
  paymentTermId: z.number().nullish(),
  paymentTermCode: z.string().nullish(),
  billingCycleId: z.number(),
  billingCycleCode: z.string(),
  billingModelId: z.number().nullish(),
  billingModelCode: z.string().nullish(),
  billingValue: z.number(),
  autoBill: z.boolean(),
  platformId: z.number(),
  paymentStructureId: z.number().nullish(),
  isActive: z.boolean(),
  createdAt: DateStringSchema,
  updatedAt: DateStringSchema,
})

export type UbsAgreement = ZodInfer<typeof UbsAgreementSchema>
